import { defineMessages } from 'react-intl';

export default defineMessages({
  summaryHeading: {
    id: 'smart-rate.how-smart-rate-works.maximizes-revenue-panel.summary-heading',
    defaultMessage: 'Optimized to deliver maximum revenue',
  },
  summaryBodyParagraph1: {
    id: 'smart-rate.how-smart-rate-works.maximizes-revenue-panel.summary-body-paragraph-1',
    defaultMessage:
      'SmartRate will explore credit amounts to determine which levels deliver the strongest performance and conversion.',
  },
  summaryBodyParagraph2: {
    id: 'smart-rate.how-smart-rate-works.maximizes-revenue-panel.summary-body-paragraph-2',
    defaultMessage:
      'Sometimes multiple bookings at a lower level earn more than one booking at a higher credit level, while other times the opposite is true.',
  },
  summaryBodyParagraph2WithLink: {
    id: 'smart-rate.how-smart-rate-works.maximizes-revenue-panel.summary-body-paragraph-2-with-link',
    defaultMessage:
      'Sometimes multiple bookings at a lower level earn more than one booking at a higher credit level, while other times the opposite is true. <faqLink>Learn more</faqLink>',
  },
  demandIllustrationClassTime: {
    id: 'smart-rate.how-smart-rate-works.maximizes-revenue-panel.demand-illustration.class-time',
    defaultMessage: '07:00 AM',
  },
  demandIllustrationClassTimeSecond: {
    id: 'smart-rate.how-smart-rate-works.maximizes-revenue-panel.demand-illustration.class-time-second',
    defaultMessage: '08:00 AM',
  },
  demandIllustrationHighDemandSubtitle: {
    id: 'smart-rate.how-smart-rate-works.maximizes-revenue-panel.demand-illustration.high-demand-subtitle',
    defaultMessage: 'High demand',
  },
  demandIllustrationLowDemandSubtitle: {
    id: 'smart-rate.how-smart-rate-works.maximizes-revenue-panel.demand-illustration.low-demand-subtitle',
    defaultMessage: 'Low demand',
  },
  demandIllustrationTotalEarnings: {
    id: 'smart-rate.how-smart-rate-works.maximizes-revenue-panel.demand-illustration.total-earnings',
    defaultMessage: 'Total earnings',
  },
  demandIllustrationLowerEarningsAmount: {
    id: 'smart-rate.how-smart-rate-works.maximizes-revenue-panel.demand-illustration.lower-earnings-amount',
    defaultMessage: '$36',
  },
  demandIllustrationLowerEarningsAmountSecond: {
    id: 'smart-rate.how-smart-rate-works.maximizes-revenue-panel.demand-illustration.lower-earnings-amount-second',
    defaultMessage: '$12',
  },
  demandIllustrationHigherEarningsAmount: {
    id: 'smart-rate.how-smart-rate-works.maximizes-revenue-panel.demand-illustration.higher-earnings-amount',
    defaultMessage: '$16',
  },
  demandIllustrationDisclaimer: {
    id: 'smart-rate.how-smart-rate-works.maximizes-revenue-panel.demand-illustration.disclaimer',
    defaultMessage: "Illustrative example. Figures don't reflect your venue",
  },
  demandIllustrationLowerCredits: {
    id: 'smart-rate.how-smart-rate-works.maximizes-revenue-panel.demand-illustration.lower-credits',
    defaultMessage: 'Lower credits',
  },
  demandIllustrationHigherCredits: {
    id: 'smart-rate.how-smart-rate-works.maximizes-revenue-panel.demand-illustration.higher-credits',
    defaultMessage: 'Higher credits',
  },
  demandIllustrationVersus: {
    id: 'smart-rate.how-smart-rate-works.maximizes-revenue-panel.demand-illustration.versus',
    defaultMessage: 'VS',
  },
});
